import { InformationEquipmentListCard } from 'app/components/equipment';
import { ReactComponent as UpcomingAccessIcon } from 'assets/images/upcoming-access.svg';
import { useGetUserInfoQuery } from 'app/hooks/user-info';
import { formatDisplayName } from '../formatDisplayName';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { selectUpcomingAccessShares } from 'services/api/shares';
import { useAppSelector } from 'services/store';
import { useFormatter } from 'shared/formatters';

interface Props {
  className?: string;
}

export default function UpcomingAccessEquipmentListCard({ className }: Props) {
  const { t } = useTranslation();

  const { formatDate } = useFormatter();

  const { data: user } = useGetUserInfoQuery();
  const upcomingAccessShares = useAppSelector(state =>
    selectUpcomingAccessShares(state, user?.email),
  );

  const items = useMemo(
    () =>
      upcomingAccessShares.slice(0, 2).map(item => ({
        i18nKey:
          'access_sharing.equipment_list.invitations.granted_access_to_from',
        values: {
          name: formatDisplayName(item.ownerName, item.ownerEmail),
          to: item.itemName,
          date: formatDate(item.startsAt),
        },
      })),
    [upcomingAccessShares],
  );

  if (!items.length) {
    return null;
  }

  return (
    <InformationEquipmentListCard
      icon={UpcomingAccessIcon}
      title={t(
        'access_sharing.equipment_list.invitations.upcoming-access.title',
      )}
      items={items}
      className={className}
    />
  );
}
